<template>
  <!-- animate-bounce class -->
  <q-btn flat class="relative-position message-popover">
    <q-icon name="mail" />
    <span class="floating label bg-negative">5</span>
    <q-menu self="top right">
      <div class="list striped">
        <p class="caption no-margin text-center text-white bg-teal">{{ $gettext('MESSAGES') }}</p>
        <div
          v-for="post in filteredPosts"
          :key="post.id"
          class="item item-link two-lines item-delimiter no-margin"
        >
          <img :src="randomAvatarUrl()" class="item-primary" />
          <div class="item-content has-secondary">
            <div>{{ post.title }}</div>
            <div>{{ randomDate() }}</div>
          </div>
          <span class="label bg-red text-white item-secondary no-margin">
            <i class="left-detail" /> {{ $gettext('NEW') }}
          </span>
        </div>
      </div>
    </q-menu>
  </q-btn>
</template>
<script>
import { QBtn, QIcon, QMenu } from 'quasar'
export default {
  components: {
    QBtn,
    QIcon,
    QMenu
  },
  computed: {
    filteredPosts () {
      return this.getPosts.slice(0, 5)
    }
  },
  mounted () {
    /*   if (this.getPosts.length < 1) {
        this.requestPosts()
      } */
  },
  methods: {
    randomDate () {
      return new Date(new Date() - Math.floor(Math.random() * 10000000000))
    },
    randomAvatarUrl () {
      return `https://api.adorable.io/avatars/face/${this.randomEye()}/${this.randomNose()}/${this.randomMouth()}/${this.randomHexColor()}`
    },
    randomHexColor () {
      return Math.random()
        .toString(16)
        .slice(2, 8)
    },
    randomEye () {
      return this.randomArrayElement([
        'eyes1',
        'eyes10',
        'eyes2',
        'eyes3',
        'eyes4',
        'eyes5',
        'eyes6',
        'eyes7',
        'eyes9'
      ])
    },
    randomNose () {
      return this.randomArrayElement([
        'nose2',
        'nose3',
        'nose4',
        'nose5',
        'nose6',
        'nose7',
        'nose8',
        'nose9'
      ])
    },
    randomMouth () {
      return this.randomArrayElement([
        'mouth1',
        'mouth10',
        'mouth11',
        'mouth3',
        'mouth5',
        'mouth6',
        'mouth7',
        'mouth9'
      ])
    },
    randomArrayElement (array) {
      return array[Math.floor(Math.random() * array.length)]
    },
    requestPosts () {
      /*  this.$http.jsonplaceholder
         .get('posts')
         .then(response => { this.setPosts(response.data) }) */
    }
  }
}
</script>
<style scoped>
.message-popover .label.floating {
  border-radius: 50%;
  top: -0.2rem;
  right: 0;
  width: 65%;
  position: absolute;
}

.list {
  max-width: 400px;
}

.item > img.item-primary:not(.thumbnail) {
  border-radius: 10px !important;
}

.item > img.item-primary {
  width: 48px;
  height: 46px;
}

.item > .item-secondary {
  width: 57px;
  font-size: 13px;
}
</style>
